const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/email-logs.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/email-logs")({
  validateSearch: (search: Record<string, unknown>): {
    status?: string;
  } => ({
    status: typeof search.status === "string" && search.status ? search.status : undefined
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});